/* esm.sh - use-sidecar@1.1.3/dist/es2015/env */
export * from "/*use-sidecar@1.1.3/esnext/dist/es2015/env.mjs";
